export const REQUESTED_APPLICATION_LIST = `REQUESTED_VALIDATE`
export const REQUESTED_APPLICATION_LIST_SUCCEEDED = `REQUESTED_APPLICATION_LIST_SUCCEEDED`
export const REQUESTED_APPLICATION_LIST_FAILED = `REQUESTED_APPLICATION_LIST_FAILED`
